// extracted by mini-css-extract-plugin
export const noWordWrap = "NoWordWrap-module--noWordWrap--v9918";